import { useTitle } from 'react-use';

export const useApplicationTitle = (
    title: string,
    suffix = ' - Anthology Illuminate',
) => {
    useTitle(`${title}${suffix}`);
};
